<div class="row mt-3 mb-3">
  <div class="col-sm-3 d-flex justify-content-start align-items-center">
    <button *ngIf="!somenteVisualizar" class="btn btn-sm btn-outline-primary" (click)="visualizar()">
      <i class="fa fa-object-group"></i>
      Atualizar cotações
    </button>
  </div>
  <div class="col-sm-9 d-flex justify-content-end align-items-center">
    <!-- <p-selectButton [options]="listOpcoes" [(ngModel)]="opcao" optionLabel="nome" optionValue="opcao" styleClass="mr-2">
    </p-selectButton> -->
    <p-selectButton [options]="listTipos" [(ngModel)]="tipo" optionLabel="nome" optionValue="tipo"
      (onChange)="visulizarCotacao()">
      <ng-template let-item>
        <i [class]="item.icon" style="font-size: 18px; margin-left: 20px; margin-right: 20px;"></i>
      </ng-template>
    </p-selectButton>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="card bg-info" [ngClass]="corOpcao()">
      <table class="table table-eddy m-0 text-white font-weight-bold">
        <tbody>
          <tr>
            <td scope="col" style="width: 48.5%;">
              <p-selectButton [options]="listOpcoes" [(ngModel)]="opcao" optionLabel="nome" optionValue="opcao"
                styleClass="mr-2">
                <ng-template let-item>
                  <i style="font-size: 15px; margin-left: 15px; margin-right: 15px;">{{item.nome}}</i>
                </ng-template>
              </p-selectButton>
            </td>
            <td scope="col" style="width: 15%;" class="text-center">{{somaItens().quantidade | number:'1.5-5'}}</td>
            <td scope="col" style="width: 15%;" class="text-center">{{somaItens().valor_unitario | number:'1.5-5'}}</td>
            <td scope="col" style="width: 15%;" class="text-center">{{somaItens().quantidade *
              somaItens().valor_unitario| number:'1.5-5'}}</td>
            <td scope="col" style="width: 15%;"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="row" *ngFor="let principal of visualizacoes; let idx = index">
  <div class="col-sm-12">
    <p-fieldset [legend]="principal.descricao">
      <table class="table table-eddy" style="font-size: 12px" *ngIf="principal.itens && principal.itens.length > 0">
        <thead>
          <tr>
            <th scope="col" style="width: 55%;">{{tipo === 'F' ? 'Item' : 'Fornecedor'}}</th>
            <th scope="col" style="width: 15%;" class="text-center">Qtd.</th>
            <th scope="col" style="width: 15%;" class="text-center">Valor Unit.</th>
            <th scope="col" style="width: 15%;" class="text-center">Total</th>
            <th scope="col" style="width: 10%;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of principal.itens; let idx = index">
            <td>{{item.descricao}}</td>
            <td class="text-center">{{item.quantidade | number:'1.5-5'}}</td>
            <td class="text-center">{{item.valor_unitario | number:'1.5-5'}}</td>
            <td class="text-center">{{(item.valor_unitario * item.quantidade) | number:'1.5-5'}}</td>
            <td class="text-center">
              <span *ngIf="vencedor(item) === 'V'" class="badge badge-success ml-2">Vencedor</span>
              <span *ngIf="vencedor(item) === 'P'" class="badge badge-danger ml-2">Perdedor</span>
              <span *ngIf="vencedor(item) === 'E'" class="badge badge-warning ml-2">Empate</span>
            </td>
          </tr>
        </tbody>
      </table>
    </p-fieldset>
  </div>
</div>



<div class="modal fade" id="dialogCotacoesCad" tabindex="-1" (mousedown)="fechar()">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (mousedown)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Inclusão de cotações</h5>
        <button type="button" class="close" (click)="fechar()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row">
          <div class="form-group col-8">
            <label for="fornecedor">Selecione o favorecido que deseja visualizar/adicionar cotações</label>
            <select [compareWith]="compareFn" [(ngModel)]="favorecido" [ngModelOptions]="{standalone: true}"
              id="fornecedor" class="form-control">
              <option *ngFor="let item of favorecidos" [ngValue]="item">{{item?.favorecido?.nome}}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th scope="col" style="width: 55%">Item</th>
                  <th scope="col" style="width: 15%" class="text-center">Qtd.</th>
                  <th scope="col" style="width: 15%" class="text-right">Valor Unit.</th>
                  <th scope="col" style="width: 15%" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of favorecido?.cotacoes; let idx = index">
                  <td>
                    <span class="word-break-all">
                      {{funcaoService.abreviarStr(item.rcmsItem?.produto_unidade?.produto?.nome, 100, true)}}
                      ({{item.rcmsItem?.produto_unidade?.unidade?.nome}})
                    </span>
                  </td>
                  <td class="text-center">{{+item.rcmsItem?.quantidade | number : '1.5-5'}}</td>
                  <td class="text-right">
                    <input #valor_unitario_ [(ngModel)]="item.valor_unitario" [ngModelOptions]="{standalone: true}"
                      type="text" class="form-control form-control-sm" unmask="typed" [imask]="imaskValor">
                  </td>
                  <td class="text-right">
                    {{+item.rcmsItem?.quantidade * +item.valor_unitario | number : '1.5-5'}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%">
          <div class="col-12 p-0">
            <button type="button" class="btn btn-sm btn-link float-right ml-2" (click)="fechar()">Fechar</button>
            <button (click)="confirmar()" type="button" class="btn btn-sm btn-primary float-right">
              <i class="fa fa-check"></i> Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>